import React, { Component } from 'react';
import { formatarReal } from '../../util/numberUtil';
import QRCodeCupomEncomenda from './QRCodeCupomEncomenda';

export default class ReciboCupomEncomenda extends Component {

    linha() {
        return <hr id='printPageButton' style={{
            borderStyle: 'dashed',
            borderWidth: 3
        }}/>
    }

    exibirLimiteCupom() {
        return <div className='printer-element'>--</div>
    }

    exibirFormasPagamento() {        
        return this.props.encomenda.formasPagamento.map((it, index) => <React.Fragment key={`formas-pagamento-${index}`}>
            <tr>
                <td colSpan="3">Forma de pagamento:</td>
            </tr>
            <tr>
                <td colSpan="3">{it.tipo}: {formatarReal(it.valor.toString())}</td>
            </tr>
            {it.quantidadeParcelas > 1 ? <>
                <tr>
                    <><strong>Parcelas: </strong>{it.quantidadeParcelas}x</>
                </tr><tr><td colSpan="3">&nbsp;</td></tr>
            </>:''}
        </React.Fragment>)
        
    }

    exibirSeguroEncomenda() {
        return (
            <>
                {this.props.encomenda.habilitadoSeguro ? <>                
                  {this.props.encomenda.seguroEncomenda.habilitadoValorDeclarado && <>
                    <tr><td colSpan="3">Valor declarado: </td></tr> 
                    <tr><td colSpan="3">do produto: {formatarReal(this.props.encomenda.seguroEncomenda.valorProduto)}</td></tr></>}
                  
                  {this.props.encomenda.seguroEncomenda.habilitadoValorNotaFiscal && <>
                    <tr><td colSpan="3">Valor nota fiscal: {formatarReal(this.props.encomenda.seguroEncomenda.valorTotalNotaFiscal)}</td></tr></>}

                    <tr><td colSpan="3">Seguro: {formatarReal(this.props.encomenda.valorSeguro)}</td></tr>

                    <tr><td colSpan="3">Valor: {formatarReal(this.props.encomenda.valorEncomenda)}</td></tr>
                
                    <tr><td colSpan="3">Valor Total: {formatarReal(this.props.encomenda.valorTotal)}</td></tr>
              </>
                : <><tr><td colSpan="3">Valor Total: {formatarReal(this.props.encomenda.valor)} </td></tr></>}
            </>
        )
    }

    exibirProduto() {
        return (
            <>
                <tr><td colSpan="3">Descrição Produto: {this.props.encomenda.descricaoProduto}</td></tr>            
                <tr><td colSpan="3">Tipo de cálculo: {this.props.encomenda.descricaoTipoCalculo}</td></tr>            
                <tr><td colSpan="3">Volumes: {this.props.encomenda.volume}</td></tr>
            </>            
        )
    }

    exibirOrigemDestino() {
        return (
            <>
                <tr>
                    <td colSpan="3">Origem: <span className='ml-2'>{this.props.encomenda.cidadeOrigem} - {this.props.encomenda.dataHoraPartida}</span></td>
                </tr>
                <tr>
                    <td colSpan="3">Destino: <span className='ml-2'>{this.props.encomenda.cidadeDestino} - {this.props.encomenda.dataHoraChegada}</span></td>
                </tr>
            </>
        )
    }

    exibirCupom(via, pessoa) {
        return <div>
            {this.exibirLimiteCupom()}
            <table className="printer-ticket">
                <thead>                
                    {this.exibirCabecalho(via, pessoa)}
                </thead>
                <tbody>                
                    {this.exibirCorpo('Remetente', this.props.encomenda.remetente, this.props.encomenda.enderecoRemetente)}
                    <tr>
                        <td colSpan="3">&nbsp;&nbsp;</td>
                    </tr>
                    {this.exibirCorpo('Destinatário', this.props.encomenda.destinatario, this.props.encomenda.enderecoDestinatario)}
                    <tr>
                        <td colSpan="3">&nbsp;&nbsp;</td>
                    </tr>
                    {this.exibirFormasPagamento()}
                    <tr>
                        <td colSpan="3">Resp. pelo pagamento: Remetente</td>
                    </tr>
                    <tr>
                        <td colSpan="3" >Status pagamento: Pago</td>
                    </tr>
                    {this.exibirSeguroEncomenda()}
                    <tr>
                        <td colSpan="3">&nbsp;&nbsp;</td>
                    </tr>
                    <tr style={{textAlign: 'center'}}>
                        <td colSpan="3">
                            <QRCodeCupomEncomenda encomenda={this.props.encomenda}/>
                        </td>
                    </tr>
                    {<tr style={{textAlign: 'center', fontWeight: 'normal!important'}}>
                        <td className="title" colSpan="3">
                            OS número: {this.props.encomenda.idPedido}
                        </td>
                    </tr>}
                    <tr>
                        <td colSpan="3">&nbsp;&nbsp;</td>
                    </tr>
                    {this.exibirProduto()}
                    <tr>
                        <td colSpan="3">&nbsp;&nbsp;</td>
                    </tr>
                    {this.exibirOrigemDestino()}
                    <tr>
                        <td colSpan="3">&nbsp;&nbsp;</td>
                    </tr>                    
                </tbody>
                <tfoot>
                    <tr>
                        <td colSpan="3" align='center'>
                            <span className="text-break" style={{paddingLeft: '10px', paddingRight: '10px'}}>
                                Observação: {this.props.encomenda.observacao}
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan="3">&nbsp;&nbsp;</td>
                    </tr>
                    <tr>
                        <td colSpan="3">&nbsp;&nbsp;</td>
                    </tr>
                </tfoot>
            </table>
            {this.exibirLimiteCupom()}
            {this.linha()}
        </div>
    }

    exibirCabecalho(label, pessoa, nomeEmpresa, cnpj) {
        return <React.Fragment>
            <tr>
                <th className="title" colSpan="3">
                    {nomeEmpresa ? nomeEmpresa : this.props.empresaSelecionada.nome}
                    {(cnpj ? cnpj : this.props.empresaSelecionada.cnpj) && <strong> - CNPJ: {cnpj ? cnpj : this.props.empresaSelecionada.cnpj}</strong>}
                    <br/>                    
                </th>
            </tr>
            <tr>
                <th colSpan="3">{this.props.encomenda.dataCriacao}</th>
            </tr>
            <tr>
                <td colSpan="3">&nbsp;&nbsp;&nbsp;&nbsp;</td>
            </tr>
            <tr style={{textAlign: 'center', fontWeight: 'normal!important'}}>
                <td colSpan="3">
                    {pessoa.nome} <br/>
                    {pessoa.cpfCnpj}
                </td>
            </tr>
            <tr style={{textAlign: 'center', fontWeight: 'normal!important'}}>
                <td className='title' colSpan="3">
                    Via {label}
                </td>
            </tr>
            <tr style={{textAlign: 'center', fontWeight: 'normal!important'}}>
                <td className="title" colSpan="3">
                    OS número: {this.props.encomenda.idPedido}
                </td>
            </tr>
        </React.Fragment>
    }

    exibirCorpo(label, pessoa, endereco) {
        return <React.Fragment>
            <tr>
                <td align="left">
                    {label}:
                </td>
            </tr>
            <span>
                <tr align="left"><td colSpan="3"><strong>Rota: </strong>{this.props.encomenda.rotaCidadeOrigem} à {this.props.encomenda.rotaCidadeDestino}</td></tr>
                <tr align="left"><td colSpan="3">Nome: {pessoa.nome}</td></tr>
                <tr align="left"><td colSpan="3">E-mail: {pessoa.email}</td></tr>
                <tr align="left"><td colSpan="3">Telefone: {pessoa.telefone}</td></tr>
                <tr align="left"><td colSpan="3">CEP: {pessoa.endereco ? pessoa.endereco.cep : endereco.cep}</td></tr>
                <tr align="left"><td colSpan="3">Endereço: {pessoa.endereco ? <> {pessoa.endereco.logradouro}, {pessoa.endereco.numero}, {pessoa.endereco.complemento}<br/>
                    {pessoa.endereco.bairro}-{pessoa.endereco.localidade}-{pessoa.endereco.uf}</>
                    : <> {endereco.logradouro}, {endereco.numero}, {endereco.complemento}<br/>
                    {endereco.bairro}-{endereco.localidade}-{endereco.uf}</>}
                </td></tr>
            </span>
        </React.Fragment>
    }

    exibirReciboEntrega() {
        return (<>
            <div className="pagebreak"></div>
            {this.exibirLimiteCupom()}
            <div style={{marginBottom: '50px'}}>                
                <h2>OS: {this.props.encomenda.idPedido}</h2>
                <h2><span>RECIBO DE ENTREGA</span></h2>
                <h3>Declaro haver recebido as mercado-<br/>rias das notas fiscais acima.</h3>
                <h2>OS: {this.props.encomenda.idPedido}</h2>
                <h2>RG:</h2>
                <h2>CPF:</h2>
                <h2>Assinatura:</h2>
            </div>
            <hr style={{ borderTop: '2px dashed' }} />
            {this.exibirEtiquetas()}
            {this.exibirLimiteCupom()}
            {this.linha()}
        </>            
    )
    }

    exibirEtiquetas() {
        if (this.props.encomenda.volume) {
            return ( <React.Fragment>
                {[...Array(this.props.encomenda.volume)
                  .keys()].map(it => (<React.Fragment key={`volume-encomenda${it}`}>                    
                    <h2>Rota: {this.props.encomenda.rotaCidadeOrigem} à {this.props.encomenda.rotaCidadeDestino}</h2>
                    <h2>Destino:</h2>
                    <div><span style={{ fontSize: 25 }}>{this.props.encomenda.cidadeDestino}</span></div>
                    <h2>Volume: {it + 1}/{this.props.encomenda.volume}</h2>
                    <h2>OS: {this.props.encomenda.idPedido}</h2>
                    <h2>Destinatário:</h2>
                    <div><span style={{ fontSize: 25 }}>{this.props.encomenda.destinatario.nome}</span></div>
                    {it + 1 !== this.props.encomenda.volume ? <hr className='mt-2' style={{ borderTop: '2px dashed' }} /> : ''}
                  </React.Fragment>))}                  
              </React.Fragment>
            )
        }
    }

    render() {
        return (
            <div>
                <div ref={this.props.referencias ? this.props.referencias.get('REMETENTE').referencia : null}>                    
                    {this.exibirCupom('Remetente', this.props.encomenda.remetente)}
                </div>
                <div ref={this.props.referencias ? this.props.referencias.get('AGENCIA').referencia : null}>                    
                    {this.exibirCupom('Agência', this.props.encomenda.remetente)}
                </div>
                <div ref={this.props.referencias ? this.props.referencias.get('DESTINATARIO').referencia : null}>
                    {this.exibirCupom('Destinatário', this.props.encomenda.destinatario)}
                </div>
                <div ref={this.props.referencias ? this.props.referencias.get('ENTREGA').referencia : null}>                    
                    {this.exibirCupom('Entrega', this.props.encomenda.remetente)}
                </div>

                <div ref={this.props.referencias ? this.props.referencias.get('RECIBO_DE_ENTREGA').referencia : null}>                    
                    {this.exibirReciboEntrega()}
                </div>
            </div>
        )

    }
    
}